module.exports = __webpack_public_path__ + "img/couples_09_V.bb509261.webp";